import { resolveApiBaseUrl } from '../services/runtimeConfig';

export function resolveBackendBaseUrl() {
  return resolveApiBaseUrl();
}

export function resolveBackendWsBaseUrl() {
  return resolveBackendBaseUrl()
    .replace(/^https:\/\//, 'wss://')
    .replace(/^http:\/\//, 'ws://');
}

export function buildSessionWsProtocol(token) {
  if (!token) return null;
  try {
    const utf8 = encodeURIComponent(String(token)).replace(/%([0-9A-F]{2})/g, (_, hex) =>
      String.fromCharCode(parseInt(hex, 16))
    );
    const encoded = window.btoa(utf8).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
    return `vl-session.${encoded}`;
  } catch {
    return null;
  }
}
